import { TWeekDay } from '../../../types/IScheduleStore';

export const WEEK_DAY_NUMBER_TO_STRING: { [key: number]: TWeekDay } = {
  0: 'SUNDAY',
  1: 'MONDAY',
  2: 'TUESDAY',
  3: 'WEDNESDAY',
  4: 'THURSDAY',
  5: 'FRIDAY',
  6: 'SATURDAY',
};
